import { MutationTree } from 'vuex';
import { ChannelIdentitiesState } from '.';
import { SET_CHANNEL_IDENTITIES } from './mutationTypes';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';

export const mutations: MutationTree<ChannelIdentitiesState> = {
  [SET_CHANNEL_IDENTITIES](state, identities: ChannelIdentityViewModel[]) {
    state.channelIdentities = identities;
  },
};
